import _ from 'lodash';
import { batch } from 'react-redux';

import {
  ADD_CONTROL_ACTION,
  CREATE_NEW_COMPONENT_STEPS,
  DELETE_CONTROL_ACTION,
  MAX_TEXT_VIEWS_QUANTITY,
  MOVE_BUTTON_TYPES,
  MOVE_CONTROL_ACTION,
  SAVE_ACTION_TYPE,
  UPDATE_CONTROL_ACTION,
  UPDATE_DATASOURCES_ACTION,
} from './../constants/editor.constants';
import { replaceFromChangedDatasource, updateDatasourceList } from './data-source.actions';
import {
  clearFormDesigner,
  createEntity,
  setImportMode,
  updateFormChanges,
  updateLayoutChanges,
  updateNodeElementsInformation,
} from './form-manager.actions';
import { handleErrors } from '../../actions/ErrorActions';
import { addSuccess } from '../../actions/SuccessActions';
import {
  addWarning,
  addWarnings,
  clearWarnings,
  enableWarnings,
} from '../../actions/WarningActions';
import {
  deleteForm as deleteFormApi,
  importForm as importFormApi,
  saveFormDefinitions,
  unpublishForm,
} from '../../api/forms';
import { WARNING_SOURCES } from '../../constants/WarningsConstants';
import { scrollIntoEditor } from '../../utils/domUtils';
import { isNilOrEmpty } from '../../utils/ramdaUtils';
import {
  ATTACHMENT_TYPES,
  DEFAULT_GRID_COLUMN_LABEL,
  DEFAULT_SINGLE_TAB_HEADER,
  FORM_KEYS,
  FORM_MODEL_ATTRIBUTES,
  SS_CONTROL_TYPE,
  ZOOM_SOURCE_TYPE,
} from '../constants/form-manager.constants';
import {
  addedElementsPayloadBuilder,
  addedImportElementsPayloadBuilder,
  deletedElementsPayloadBuilder,
  diffPayloadBuilder,
  getAddedElementsArrayFormModel,
  getAutogeneratedZoomMappings,
  getDeletedElementsArrayFormModel,
  getDeleteElementParams,
  getFormIdsList,
  getLastControlIdInAdvancedTextBox,
  getMergedZoomCommonProps,
  getPreviousControlIdForNewZoom,
  getSearchIds,
  makeDiffForPayloadBuilder,
  movedChildrenNodesArray,
  movedElementsPayloadBuilder,
  validateWarnings,
} from '../utils/actions/editor.actions.utils';
import { preprocessRules } from '../utils/actions/form-manager.actions.utils';
import { clearRules } from '../utils/actions/rule.actions.utils';
import { difference, ElementGenerator, removeChildrenNodes } from '../utils/editor.utils';
import { findClosestParentWithEntityName } from '../utils/form-manager.utils';

export const ORIGINAL_FORM_MODEL = 'ORIGINAL_FORM_MODEL';
export const ORIGINAL_DATA_SOURCES = 'ORIGINAL_DATA_SOURCES';
export const SESSION_FORM_MODEL = 'SESSION_FORM_MODEL';
export const UPDATE_FORM_INFO = 'UPDATE_FORM_INFO';
export const TOGGLE_EDIT_MODE = 'TOGGLE_EDIT_MODE';
export const COPY_TEMP_STATE = 'COPY_TEMP_STATE';
export const SET_SELECTED_CONTROL = 'SET_SELECTED_CONTROL';
export const SET_SEARCH_RESULT = 'SET_SEARCH_RESULT';

export const UPDATE_FORM_MODEL_DELETE_ELEMENTS = 'UPDATE_FORM_MODEL_DELETE_ELEMENTS';
export const UPDATE_FORM_MODEL_ADD_ELEMENT = 'UPDATE_FORM_MODEL_ADD_ELEMENT';
export const ADD_CHILDREN_NODE_ITEM_FROM_FORM_MODEL = 'ADD_CHILDREN_NODE_ITEM_FROM_FORM_MODEL';
export const DELETE_CHILDREN_NODE_ITEM_FROM_FORM_MODEL =
  'DELETE_CHILDREN_NODE_ITEM_FROM_FORM_MODEL';
export const UPDATE_NEW_ADDED_ELEMENT_LIST_AFTER_DELETION =
  'UPDATE_NEW_ADDED_ELEMENT_LIST_AFTER_DELETION';
export const ADD_NEW_ELEMENT_ID_LIST = 'ADD_NEW_ELEMENT_ID_LIST';
export const UPDATE_ADDED_FIELDS_FORM_MODEL_LIST = 'UPDATE_ADDED_FIELDS_FORM_MODEL_LIST';
export const ADD_DELETED_NEW_ELEMENT = 'ADD_DELETED_NEW_ELEMENT';
export const CHANGE_DATASOURCE = 'CHANGE_DATASOURCE';
export const DELETE_DATASOURCES = 'DELETE_DATASOURCES';
export const REPLACE_DATASOURCE = 'REPLACE_DATASOURCE';
export const UPDATE_CONTROL = 'UPDATE_CONTROL';
export const UPDATE_FORM_MODEL_BY_ID_AND_PROP = 'UPDATE_FORM_MODEL_BY_ID_AND_PROP';

export const MOVE_CONTROL_BY_DND_WITHIN_CONTAINER = 'MOVE_CONTROL_BY_DND_WITHIN_CONTAINER';
export const MOVE_CONTROL_BY_DND_TO_ANOTHER_CONTAINER = 'MOVE_CONTROL_BY_DND_TO_ANOTHER_CONTAINER';
export const MOVE_CONTROL_BY_DND_TO_EMPTY_CONTAINER = 'MOVE_CONTROL_BY_DND_TO_EMPTY_CONTAINER';
export const MOVE_CONTROL_BY_BUTTON = 'MOVE_CONTROL_BY_BUTTON';
export const UPDATE_MOVED_FIELDS_AFTER_MOVE = 'UPDATE_MOVED_FIELDS_AFTER_MOVE';
export const CLEAR_MOVED_FIELDS = 'CLEAR_MOVED_FIELDS';
export const CLEAR_CHANGED_DATASOURCES = 'CLEAR_CHANGED_DATASOURCES';
export const SET_CONFIRM_MODAL_OPEN = 'SET_CONFIRM_MODAL_OPEN';
export const ADD_API_CONFIGURATIONS = 'ADD_API_CONFIGURATIONS';
export const CHANGE_IS_DOCK_TO_BOTTOM = 'CHANGE_IS_DOCK_TO_BOTTOM';
export const SET_HEIGHT_OF_TABLE = 'SET_HEIGHT_OF_TABLE';
export const SET_WIDTH_OF_TABLE = 'SET_WIDTH_OF_TABLE';

export const UPDATE_USER_ACTION_ARRAY = 'UPDATE_USER_ACTION_ARRAY';
export const UNDO_USER_ACTION = 'UNDO_USER_ACTION';
export const REDO_USER_ACTION = 'REDO_USER_ACTION';
export const REMOVE_FROM_DELETED_ELEMENT_ARRAY = 'REMOVE_FROM_DELETED_ELEMENT_ARRAY';
export const ADD_ELEMENTS_TO_FORM_MODEL = 'ADD_ELEMENTS_TO_FORM_MODEL';
export const REPLACE_ADDED_ELEMENTS_TO_FORM_MODEL = 'REPLACE_ADDED_ELEMENTS_TO_FORM_MODEL';

export const updateUserActionArray = ({ actionType, userChanges }) => {
  return {
    type: UPDATE_USER_ACTION_ARRAY,
    payload: {
      actionType,
      userChanges,
    },
  };
};

export const setOriginalFormModel = () => ({
  type: ORIGINAL_FORM_MODEL,
  formKey: FORM_KEYS.EDITOR,
});

export const setOriginalDataSources = () => ({
  type: ORIGINAL_DATA_SOURCES,
  formKey: FORM_KEYS.EDITOR,
});

export const setSessionFormModel = () => ({
  type: SESSION_FORM_MODEL,
  formKey: FORM_KEYS.EDITOR,
});

export const setConfirmModalOpen = (confirmModalOpen) => ({
  type: SET_CONFIRM_MODAL_OPEN,
  payload: { confirmModalOpen },
});

export const updateFormModelByIdAndProp = (id, prop, value, needPersistUserAction = true) => {
  return (dispatch, getState) => {
    const {
      formModel,
      formInfo,
      AddedFieldsFormModel: addedElements,
    } = getState().formDesigner.EDITOR;
    const prevItemState = formModel[id];

    const updateControlParams = {
      prevItemState: {
        id,
        changedPropertyPrevState: { [prop]: prevItemState[prop] },
      },
      itemChanges: {
        id,
        controlChanges: { [prop]: value },
      },
    };

    if (prop === FORM_MODEL_ATTRIBUTES.GRID_TYPE && ATTACHMENT_TYPES.includes(value)) {
      const subGridId = prevItemState.childrenNodes?.find(
        (id) => formModel[id].controlType === SS_CONTROL_TYPE.SUB_GRID
      );
      if (subGridId) {
        const subGridComponent = formModel[subGridId];
        const { deletedElementParams } = getDeleteElementParams({
          element: subGridComponent,
          controlId: subGridId,
          controlType: SS_CONTROL_TYPE.SUB_GRID,
          parent: id,
          formModel,
          addedElements,
          formInfo,
        });
        updateControlParams.deletedElementParams = deletedElementParams;
      }
    }

    batch(() => {
      needPersistUserAction &&
        dispatch(
          updateUserActionArray({
            actionType: UPDATE_CONTROL_ACTION,
            userChanges: updateControlParams,
          })
        );
      dispatch({
        type: UPDATE_FORM_MODEL_BY_ID_AND_PROP,
        payload: {
          id,
          prop,
          value,
        },
      });
    });
  };
};

export const updateFormInfo = (formInfo) => ({
  type: UPDATE_FORM_INFO,
  payload: {
    formInfo,
  },
});

export const addChangedDatasource = ({ dataSource, datasourceAction, controlId }) => {
  return (dispatch, getState) => {
    const currentChangedDataSourceArr = getState().formDesigner.EDITOR.changedDatasources ?? [];
    const currentChangedDataSource = currentChangedDataSourceArr?.find(
      (item) => item.dataSourceKey === dataSource.dataSourceKey
    );
    const currentDataSourceState = getState().formDesigner.EDITOR.dataSources[
      dataSource.dataSourceKey
    ];

    const controlPrevState = controlId && getState().formDesigner.EDITOR.formModel[controlId];

    const newDataSourceState = {
      ...dataSource,
      dataSourceProperties: {
        ...dataSource.dataSourceProperties,
        containerFormName: dataSource.containerFormName,
      },
    };

    const datasourceChanges = {
      currentChangedDataSource,
      currentDataSourceState,
      pureDataSource: dataSource,
      nextChangedDataSource: datasourceAction === 'add' ? newDataSourceState : dataSource,
      controlPrevState,
      datasourceAction,
    };

    dispatch(
      updateUserActionArray({
        actionType: UPDATE_DATASOURCES_ACTION,
        userChanges: datasourceChanges,
      })
    );
    dispatch({
      type: CHANGE_DATASOURCE,
      payload: {
        dataSource,
      },
    });
  };
};

export const deleteChangedDatasources = ({ dataSourcesKeys }) => ({
  type: DELETE_DATASOURCES,
  payload: {
    dataSourcesKeys,
  },
});

export const copyTempState = (clear) => ({
  type: COPY_TEMP_STATE,
  payload: {
    clear,
  },
});

export const updateFormModelAddNewController = ({ element }) => ({
  type: UPDATE_FORM_MODEL_ADD_ELEMENT,
  payload: {
    element,
  },
});

export const updateFormModelDeleteController = (controlsIds) => ({
  type: UPDATE_FORM_MODEL_DELETE_ELEMENTS,
  payload: {
    controlsIds,
  },
});

export const updateFormModelParentElementAddNewController = ({
  controlParentId,
  childNodeId,
  previousControlId,
}) => ({
  type: ADD_CHILDREN_NODE_ITEM_FROM_FORM_MODEL,
  payload: {
    controlParentId,
    childNodeId,
    previousControlId,
  },
});

export const updateFormModelParentElementDeleteNewController = (controlParentId, childNodeId) => ({
  type: DELETE_CHILDREN_NODE_ITEM_FROM_FORM_MODEL,
  payload: {
    controlParentId,
    childNodeId,
  },
});

export const updateAddedElementsAfterDeletion = () => ({
  type: UPDATE_NEW_ADDED_ELEMENT_LIST_AFTER_DELETION,
});

export const addNewElementArray = ({ element, optionsSelect, previousControlId }) => ({
  type: ADD_NEW_ELEMENT_ID_LIST,
  payload: {
    element,
    optionsSelect,
    previousControlId,
  },
});

export const addDeletedNewElementArray = (element) => ({
  type: ADD_DELETED_NEW_ELEMENT,
  payload: {
    element,
  },
});

export const updateAddedFieldsFormModelList = () => {
  return {
    type: UPDATE_ADDED_FIELDS_FORM_MODEL_LIST,
  };
};

export const addApiConfigurations = (apiConfigurations) => ({
  type: ADD_API_CONFIGURATIONS,
  payload: {
    apiConfigurations,
  },
});

export const changeElementPositionFormModel = (element, moveType, needPersistUserAction = true) => {
  const { controlId = '', parent = '' } = element;

  return (dispatch, getState) => {
    const { formModel } = getState().formDesigner.EDITOR;
    const childrenNodes = _.clone(formModel?.[parent].childrenNodes);

    const movedControlParams = {
      element,
      moveType,
    };

    batch(() => {
      dispatch(updateMovedFieldsFormModelAfterMove(parent, controlId));
      dispatch(
        moveControlByButton(parent, movedChildrenNodesArray(childrenNodes, controlId, moveType))
      );
      needPersistUserAction &&
        dispatch(
          updateUserActionArray({
            actionType: MOVE_CONTROL_ACTION,
            userChanges: movedControlParams,
          })
        );
    });
  };
};

export const deleteElementFromFormModel = (element, needPersistUserAction = true) => {
  const { controlId = '', parent = '', controlType = '' } = element;
  return (dispatch, getState) => {
    const {
      formModel,
      formInfo,
      AddedFieldsFormModel: addedElements,
    } = getState().formDesigner.EDITOR;
    if (element) {
      const {
        newElement,
        controlsIds,
        elementInAddedArray,
        deletedElementParams,
      } = getDeleteElementParams({
        element,
        controlId,
        controlType,
        parent,
        formModel,
        addedElements,
        formInfo,
      });

      batch(() => {
        needPersistUserAction &&
          dispatch(
            updateUserActionArray({
              actionType: DELETE_CONTROL_ACTION,
              userChanges: deletedElementParams,
            })
          );
        if (!elementInAddedArray) {
          dispatch(addDeletedNewElementArray(newElement));
        }
        if (elementInAddedArray) {
          dispatch(updateFormModelDeleteController(controlsIds));
          dispatch(updateAddedElementsAfterDeletion());
        }
        dispatch(updateFormModelParentElementDeleteNewController(parent, controlId));
        dispatch(setSelectedControl('formBox', false));
      });
    }
  };
};

export const deleteSubgridFromGrid = (gridId) => {
  return (dispatch, getState) => {
    const { formModel } = getState().formDesigner.EDITOR;
    const gridChildrenNodes = formModel[gridId].childrenNodes;
    const subGridId = gridChildrenNodes.find(
      (id) => formModel[id].controlType === SS_CONTROL_TYPE.SUB_GRID
    );
    const subGridComponent = formModel[subGridId];
    if (subGridComponent) {
      dispatch(deleteElementFromFormModel(subGridComponent, false));
    }
  };
};

export const getIsAdvancedTextBoxValid = ({ controlId, newControlType, translateString }) => {
  return (dispatch, getState) => {
    const { formModel } = getState().formDesigner.EDITOR;
    const control = formModel[controlId];
    const parent = formModel[control?.parent];

    dispatch(clearWarnings());

    if (
      control?.controlType !== SS_CONTROL_TYPE.TEXT_BOX &&
      parent?.controlType !== SS_CONTROL_TYPE.ADVANCED_TEXT_BOX
    ) {
      return false;
    }

    const container = formModel[parent?.parent];

    if (
      newControlType === SS_CONTROL_TYPE.TEXT_VIEW &&
      container?.controlType === SS_CONTROL_TYPE.PANEL
    ) {
      const textViews = parent?.childrenNodes.filter(
        (controlId) => formModel[controlId]?.controlType === SS_CONTROL_TYPE.TEXT_VIEW
      );

      if (textViews?.length < MAX_TEXT_VIEWS_QUANTITY) {
        return true;
      }

      dispatch(
        addWarning({
          instanceId: controlId,
          source: WARNING_SOURCES.EDITOR,
          message: translateString(
            'Only one ssTextView control can be added to ssTextBox control!'
          ),
        })
      );
      dispatch(enableWarnings());

      return false;
    }

    return true;
  };
};

export const updateControl = ({ id, controlChanges, needPersistUserAction = true }) => {
  return (dispatch, getState) => {
    const prevItemState = getState().formDesigner.EDITOR.formModel[id];
    const changedPropertyArr = Object.keys(controlChanges).reduce((acc, cur) => {
      acc[cur] = prevItemState[cur];
      return acc;
    }, {});

    clearRules(controlChanges, prevItemState);

    const updateControlParams = {
      prevItemState: {
        id,
        changedPropertyPrevState: { ...changedPropertyArr },
      },
      itemChanges: {
        id,
        controlChanges,
      },
    };

    batch(() => {
      needPersistUserAction &&
        dispatch(
          updateUserActionArray({
            actionType: UPDATE_CONTROL_ACTION,
            userChanges: updateControlParams,
          })
        );
      dispatch({
        type: UPDATE_CONTROL,
        payload: {
          id,
          controlChanges,
        },
      });
    });
  };
};

export const clearMovedFields = () => ({
  type: CLEAR_MOVED_FIELDS,
});

export const clearChangedDatasources = () => ({
  type: CLEAR_CHANGED_DATASOURCES,
});

export const toggleEditMode = (active) => ({
  type: TOGGLE_EDIT_MODE,
  payload: {
    active,
  },
});

export const setSelectedControl = (controlId, showControlWrapper) => ({
  type: SET_SELECTED_CONTROL,
  payload: {
    controlId,
    showControlWrapper,
  },
});

export const cancelEditor = () => (dispatch) => {
  batch(() => {
    dispatch(clearFormDesigner());
    dispatch(toggleEditMode(false));
  });
};

export const updateFormInformationAfterEdition = (subFormsInfo) => (dispatch, getState) => {
  const { formModel } = getState().formDesigner.EDITOR;
  const formNameList = Object.keys(subFormsInfo || []);
  formNameList.forEach((formName) => {
    const listFormId = getFormIdsList(formModel, formName);
    listFormId.forEach((id) => {
      batch(() => {
        dispatch(
          updateFormModelByIdAndProp(
            id,
            FORM_MODEL_ATTRIBUTES.FORM_LAST_MODIFIED,
            subFormsInfo[formName].formLastModified,
            false
          )
        );
        dispatch(
          updateFormModelByIdAndProp(
            id,
            FORM_MODEL_ATTRIBUTES.FORM_VERSION,
            subFormsInfo[formName].formVersion,
            false
          )
        );
        dispatch(
          updateFormModelByIdAndProp(
            id,
            FORM_MODEL_ATTRIBUTES.FORM_STATE,
            subFormsInfo[formName].formState,
            false
          )
        );
      });
    });
  });
};

export const saveEditor = ({ saveAction, formName, redirectToAnotherForm }) => {
  return async (dispatch, getState) => {
    const {
      formModel,
      AddedFieldsFormModel,
      DeletedFieldsFormModel,
      MovedFieldsFormModel,
      formInfo,
      originalFormModel,
      changedDatasources,
      dataSources,
      isImportMode,
    } = getState().formDesigner.EDITOR;

    const actualFormId = formInfo.formId;

    const addedElementsFormModelArray = getAddedElementsArrayFormModel(AddedFieldsFormModel);
    const deletedElementsFormModelArray = getDeletedElementsArrayFormModel(
      DeletedFieldsFormModel,
      addedElementsFormModelArray
    );

    const formKey = formInfo.formKey;

    const addedFields = isImportMode
      ? addedImportElementsPayloadBuilder(
          formModel,
          formInfo,
          AddedFieldsFormModel ?? [],
          DeletedFieldsFormModel ?? []
        )
      : addedElementsPayloadBuilder(AddedFieldsFormModel ?? [], formModel, formInfo);

    const deletedFields = deletedElementsPayloadBuilder(
      DeletedFieldsFormModel ?? [],
      originalFormModel,
      formInfo
    );

    const movedFields = movedElementsPayloadBuilder(
      MovedFieldsFormModel ?? [],
      addedFields ?? [],
      formModel,
      formInfo
    );

    const deletedResultFields = isImportMode
      ? deletedFields.filter((f) => f.containerFormName !== formKey)
      : deletedFields;

    const movedResultFields = isImportMode
      ? movedFields.filter((f) => f.containerFormName !== formKey)
      : movedFields;

    if (formModel) {
      dispatch(clearWarnings());
      const formWarnings = validateWarnings(formModel);

      if (formWarnings.length > 0) {
        dispatch(addWarnings(formWarnings));
        dispatch(enableWarnings());
        return;
      }
    }

    const formModelWithoutChildren = removeChildrenNodes(formModel);
    const originalFormModelWithoutChildren = removeChildrenNodes(originalFormModel);

    const tempDiff = difference(formModelWithoutChildren, originalFormModelWithoutChildren);
    const diff = makeDiffForPayloadBuilder(tempDiff, formModel, formInfo);
    const diffPayload = diffPayloadBuilder(diff, addedElementsFormModelArray);

    const preprocessedRules = preprocessRules(diffPayload, true);

    const modifiedFields = isImportMode
      ? preprocessedRules.filter((r) => r.containerFormName !== formKey)
      : preprocessedRules;

    const preprocessedAddedFields = preprocessRules(addedFields, true);

    const formResponse = await saveFormDefinitions({
      formDefinition: {
        formKey: formInfo.formKey,
        formId: formInfo.formId,
        dataSources: isImportMode ? dataSources : changedDatasources,
        modified: modifiedFields,
        ...((addedElementsFormModelArray?.length > 0 || isImportMode) && {
          added: preprocessedAddedFields,
        }),
        ...(deletedElementsFormModelArray?.length > 0 && {
          deleted: deletedResultFields,
        }),
        ...(MovedFieldsFormModel?.length > 0 && {
          moved: movedResultFields,
        }),
        ...(!isNilOrEmpty(saveAction) && {
          overWrite: true,
          ...(saveAction === SAVE_ACTION_TYPE.SAVE_AS_OTHER_FORM && {
            saveAsName: formName,
          }),
          saveAction,
        }),
        ...([
          SAVE_ACTION_TYPE.CREATE_FORM,
          SAVE_ACTION_TYPE.IMPORT,
          SAVE_ACTION_TYPE.IMPORT_AS_PILGRIM,
        ].includes(saveAction) && { formInfo }),
      },
    });

    if (!formResponse.hasError) {
      const dataSourcesKeys = changedDatasources
        ?.filter((e) => e?.changeType === 'DELETED')
        ?.map((e) => e?.dataSourceKey);
      batch(() => {
        dispatch(addSuccess({ message: 'Form Saved Successfully' }));
        const { formInfo, subFormsInfo, formChanges } = formResponse;

        dispatch(deleteChangedDatasources({ dataSourcesKeys }));
        dispatch(updateFormInformationAfterEdition(subFormsInfo));
        dispatch(setOriginalFormModel());
        dispatch(setOriginalDataSources());
        dispatch(updateFormInfo(formInfo));
        dispatch(updateAddedFieldsFormModelList());
        dispatch(clearChangedDatasources());
        dispatch(clearMovedFields());
        dispatch(setSessionFormModel());
        dispatch(updateFormChanges(formChanges));
        dispatch(updateLayoutChanges(formChanges));
        dispatch(updateNodeElementsInformation(formChanges));
        isImportMode && dispatch(setImportMode(false));

        if (actualFormId !== formInfo.formId || isImportMode) {
          redirectToAnotherForm({
            formId: formInfo.formId,
            formKey: formInfo.formKey,
            entityType: formInfo.formEntityKey,
          });
        }
      });
    } else if (Array.isArray(formResponse.errors)) {
      dispatch(handleErrors(formResponse.errors));
    }
  };
};

export const publishFormEditor = ({ redirectToPrevPage }) => {
  return async (dispatch, getState) => {
    const {
      formModel,
      formInfo,
      originalFormModel,
      DeletedFieldsFormModel,
      AddedFieldsFormModel,
      MovedFieldsFormModel,
    } = getState().formDesigner.EDITOR;

    const addedElementsFormModelArray = getAddedElementsArrayFormModel(AddedFieldsFormModel);
    const deletedElementsFormModelArray = getDeletedElementsArrayFormModel(
      DeletedFieldsFormModel,
      addedElementsFormModelArray
    );

    const addedFields = addedElementsPayloadBuilder(
      AddedFieldsFormModel ?? [],
      formModel,
      formInfo
    );

    const deletedFields = deletedElementsPayloadBuilder(
      DeletedFieldsFormModel ?? [],
      originalFormModel,
      formInfo
    );

    const movedFields = movedElementsPayloadBuilder(
      MovedFieldsFormModel ?? [],
      addedFields ?? [],
      formModel,
      formInfo
    );

    const formModelWithoutChildren = removeChildrenNodes(formModel);
    const originalFormModelWithoutChildren = removeChildrenNodes(originalFormModel);

    const tempDiff = difference(formModelWithoutChildren, originalFormModelWithoutChildren);
    const diff = makeDiffForPayloadBuilder(tempDiff, formModel, formInfo);
    const diffPayload = diffPayloadBuilder(diff, addedElementsFormModelArray);

    const formResponse = await saveFormDefinitions({
      formDefinition: {
        formKey: formInfo.formKey,
        formId: formInfo.formId,
        modified: preprocessRules(diffPayload, true),
        publish: true,
        ...(addedElementsFormModelArray?.length > 0 && {
          added: addedFields,
        }),
        ...(deletedElementsFormModelArray?.length > 0 && {
          deleted: deletedFields,
        }),
        ...(MovedFieldsFormModel?.length > 0 && {
          moved: movedFields,
        }),
      },
    });

    if (!formResponse.hasError) {
      batch(() => {
        dispatch(addSuccess({ message: 'Form Published Successfully' }));
        const { formInfo, subFormsInfo } = formResponse;
        dispatch(updateFormInformationAfterEdition(subFormsInfo));
        dispatch(setOriginalFormModel());
        dispatch(setOriginalDataSources());
        dispatch(updateFormInfo(formInfo));
        dispatch(toggleEditMode(false));
        dispatch(updateAddedFieldsFormModelList());
      });
      redirectToPrevPage();
    } else if (Array.isArray(formResponse.errors)) {
      dispatch(
        handleErrors(formResponse.errors, {
          defaultMessage:
            'An error has occurred during Form publish. Please refer to the console for more details.',
        })
      );
    }
  };
};

export const deleteForm = (params, redirectToPrevPage) => {
  return async (dispatch) => {
    const formResponse = await deleteFormApi(params);

    if (!formResponse.hasError) {
      dispatch(addSuccess({ message: 'Form Deleted Successfully' }));
      redirectToPrevPage();
    } else if (Array.isArray(formResponse.errors)) {
      dispatch(
        handleErrors(formResponse.errors, {
          defaultMessage:
            'An error has occurred during Form deletion. Please refer to the console for more details.',
        })
      );
    }
  };
};

export const loadEditor = ({
  entityViewName,
  entityType,
  containerWorkflowKey,
  workflowKey,
  stepId,
  itmId,
  workflowId,
  formKey,
  formId,
  entityName,
  isCreateForm,
  newFormParams,
  isImportForm,
  formEntity,
  formDefinition,
}) => {
  return async (dispatch) => {
    await dispatch(
      createEntity({
        entityViewName,
        entityType,
        orgId: '',
        formKey,
        formId,
        containerWorkflowKey,
        workflowKey,
        workflowId,
        stepId,
        storeKey: FORM_KEYS.EDITOR,
        itmId,
        entityName,
        isCreateForm,
        newFormParams,
        isImportForm,
        formEntity,
        formDefinition,
      })
    );
    batch(() => {
      dispatch(toggleEditMode(true));
      dispatch(copyTempState());
      dispatch(setOriginalFormModel());
      dispatch(setOriginalDataSources());
      dispatch(setSessionFormModel());
      dispatch(setSelectedControl('formBox', false));
      dispatch(changeIsDockToBottom(true));
      isImportForm && dispatch(setImportMode(true));
    });
  };
};

export const moveControlByDndWithinContainer = (dragId, dropId, parentComponent) => {
  return {
    type: MOVE_CONTROL_BY_DND_WITHIN_CONTAINER,
    payload: {
      dragId,
      dropId,
      parentComponent,
    },
  };
};

export const moveControlByDndToAnotherContainer = (
  dragId,
  dropId,
  dragParentComponent,
  dropParentComponent
) => {
  return {
    type: MOVE_CONTROL_BY_DND_TO_ANOTHER_CONTAINER,
    payload: {
      dragId,
      dropId,
      dragParentComponent,
      dropParentComponent,
    },
  };
};

export const setWidthOfTable = (value) => {
  return {
    type: SET_WIDTH_OF_TABLE,
    payload: {
      tableWidth: value,
    },
  };
};

export const setHeightOfTable = (value) => {
  return {
    type: SET_HEIGHT_OF_TABLE,
    payload: {
      tableHeight: value,
    },
  };
};

export const changeIsDockToBottom = (value) => {
  return {
    type: CHANGE_IS_DOCK_TO_BOTTOM,
    payload: {
      isDockToBottom: value,
    },
  };
};

export const moveControlByDndToEmptyContainer = (dragId, dragParentComponent, dropComponent) => {
  return {
    type: MOVE_CONTROL_BY_DND_TO_EMPTY_CONTAINER,
    payload: {
      dragId,
      dragParentComponent,
      dropComponent,
    },
  };
};

export const moveControlByButton = (parentControlId, childrenNodes) => ({
  type: MOVE_CONTROL_BY_BUTTON,
  payload: {
    parentControlId,
    childrenNodes,
  },
});

export const updateMovedFieldsFormModelAfterMove = (parentControlId, controlId) => ({
  type: UPDATE_MOVED_FIELDS_AFTER_MOVE,
  payload: {
    parentControlId,
    controlId,
  },
});

export const addNewSubGridToFormModel = (component) => (dispatch) => {
  const controlParentId = component.controlId;
  const subGrid = ElementGenerator({
    selectedType: SS_CONTROL_TYPE.SUB_GRID,
    controlParentId,
    entityName: component.entityName,
  });

  const subGridControlId = Object.keys(subGrid)[0];
  const prevControlId = component.childrenNodes[component.childrenNodes.length - 1];

  const newComponentActionParam = {
    control_1: {
      element: subGrid,
      controlId: subGridControlId,
      controlParentId,
      previousControlId: prevControlId,
      optionsSelect: [],
    },
  };

  batch(() => {
    dispatch(
      addControlToStore({
        element: subGrid,
        controlId: subGridControlId,
        controlParentId,
        previousControlId: prevControlId,
        optionsSelect: [],
      })
    );
    dispatch(
      updateUserActionArray({
        actionType: ADD_CONTROL_ACTION,
        userChanges: newComponentActionParam,
      })
    );
  });
};

export const addNewColumnToFormModel = (component) => (dispatch) => {
  const controlParentId = component.parent;
  const newColumn = ElementGenerator({
    selectedType: SS_CONTROL_TYPE.GRID_COLUMN,
    controlParentId,
    defaultLabel: DEFAULT_GRID_COLUMN_LABEL,
    entityName: component.entityName,
  });

  const newColumnControlId = Object.keys(newColumn)[0];
  const prevControlId = component.controlId;

  const newComponentActionParam = {
    control_1: {
      element: newColumn,
      controlId: newColumnControlId,
      controlParentId,
      previousControlId: prevControlId,
      optionsSelect: [],
    },
  };

  batch(() => {
    dispatch(
      addControlToStore({
        element: newColumn,
        controlId: newColumnControlId,
        controlParentId,
        previousControlId: prevControlId,
        optionsSelect: [],
      })
    );
    dispatch(
      updateUserActionArray({
        actionType: ADD_CONTROL_ACTION,
        userChanges: newComponentActionParam,
      })
    );
  });
};

export const addNewSingleTabToFormModel = (component) => (dispatch) => {
  const controlParentId = component.parent;
  const newSingleTab = ElementGenerator({
    selectedType: SS_CONTROL_TYPE.SINGLE_TAB,
    controlParentId,
    defaultLabel: DEFAULT_SINGLE_TAB_HEADER,
  });

  const newSingleTabControlId = Object.keys(newSingleTab)[0];
  const prevControlId = component.controlId;

  const newComponentActionParam = {
    control_1: {
      element: newSingleTab,
      controlId: newSingleTabControlId,
      controlParentId,
      previousControlId: prevControlId,
      optionsSelect: [],
    },
  };

  batch(() => {
    dispatch(
      addControlToStore({
        element: newSingleTab,
        controlId: newSingleTabControlId,
        controlParentId,
        previousControlId: prevControlId,
        optionsSelect: [],
      })
    );
    dispatch(
      updateUserActionArray({
        actionType: ADD_CONTROL_ACTION,
        userChanges: newComponentActionParam,
      })
    );
  });
};

export const addNewZoomToFormModel = (component) => (dispatch, getState) => {
  const { formModel } = getState().formDesigner.EDITOR;

  const controlParentId = component.parent;
  const previousControlId = getPreviousControlIdForNewZoom({
    controlParentId,
    formModel,
  });
  const previousControl = formModel[previousControlId];

  const commonZoomProps =
    previousControl?.controlType === SS_CONTROL_TYPE.ZOOM &&
    previousControl?.zoomSource === ZOOM_SOURCE_TYPE.ENTITY
      ? getMergedZoomCommonProps(previousControl)
      : { dataLookUpType: '', dataObject: '', zoomSource: ZOOM_SOURCE_TYPE.FORM };

  const control = ElementGenerator({
    selectedType: SS_CONTROL_TYPE.ZOOM,
    controlParentId,
    isEntity: true,
    dataModel: component.entityName,
    defaultLabel: 'Zoom',
    commonZoomProps,
  });

  const controlId = control && Object.keys(control)[0];

  const newComponentActionParam = {
    control_1: {
      element: control,
      controlId,
      controlParentId,
      previousControlId,
      optionsSelect: [],
    },
  };

  batch(() => {
    dispatch(
      addControlToStore({
        element: control,
        controlId,
        controlParentId,
        previousControlId,
        optionsSelect: [],
      })
    );
    dispatch(
      updateUserActionArray({
        actionType: ADD_CONTROL_ACTION,
        userChanges: newComponentActionParam,
      })
    );
  });
};

export const addNewTextViewToFormModel = (component, dataModel) => (dispatch, getState) => {
  const { formModel } = getState().formDesigner.EDITOR;

  const controlParentId = component.parent;
  const previousControlId = getLastControlIdInAdvancedTextBox({
    controlParentId,
    formModel,
  });

  const control = ElementGenerator({
    selectedType: SS_CONTROL_TYPE.TEXT_VIEW,
    controlParentId,
    isEntity: false,
    dataModel,
    defaultLabel: 'TextView',
  });

  const controlId = control && Object.keys(control)[0];

  const newComponentActionParam = {
    control_1: {
      element: control,
      controlId,
      controlParentId,
      previousControlId,
      optionsSelect: [],
    },
  };

  batch(() => {
    dispatch(
      addControlToStore({
        element: control,
        controlId,
        controlParentId,
        previousControlId,
        optionsSelect: [],
      })
    );
    dispatch(
      updateUserActionArray({
        actionType: ADD_CONTROL_ACTION,
        userChanges: newComponentActionParam,
      })
    );
  });
};

export const addElementToFormModel = ({
  selectedType,
  controlParentId,
  dataModel,
  isEntity,
  defaultLabel,
  previousControlId,
  optionsSelect,
  nodeProperties,
  formName,
  dispatchStepChange,
}) => (dispatch, getState) => {
  let element;
  let controlId;
  const { entityDefinition, formModel, formInfo } = getState().formDesigner.EDITOR;
  const { entityResolverRules = [] } = getState().translations;

  switch (selectedType) {
    case SS_CONTROL_TYPE.TEXT_BOX: {
      const advancedTextBoxControl = ElementGenerator({
        selectedType: SS_CONTROL_TYPE.ADVANCED_TEXT_BOX,
        controlParentId,
        isEntity: true,
        dataModel,
        defaultLabel: '',
      });
      const advancedTextBoxControlId = Object.keys(advancedTextBoxControl)[0];

      element = ElementGenerator({
        selectedType,
        controlParentId: advancedTextBoxControlId,
        isEntity,
        dataModel,
        defaultLabel,
      });
      controlId = Object.keys(element)[0];

      const newComponentActionParam = {
        control_1: {
          element: advancedTextBoxControl,
          controlId: advancedTextBoxControlId,
          controlParentId,
          previousControlId,
          optionsSelect,
        },
        control_2: {
          element,
          controlId,
          controlParentId: advancedTextBoxControlId,
          previousControlId: '',
          optionsSelect,
        },
      };

      const entityResolverRule = entityResolverRules.find(
        (rule) => rule.columnName === element[controlId]?.fieldName
      );

      const autogeneratedZoom = entityResolverRule
        ? ElementGenerator({
            selectedType: SS_CONTROL_TYPE.ZOOM,
            controlParentId: advancedTextBoxControlId,
            defaultLabel: 'Zoom',
            commonZoomProps: {
              dataObject: entityResolverRule.resolver_type,
              zoomSource: ZOOM_SOURCE_TYPE.ENTITY,
              dataLookUpType: 'SMARTSOLVEDATA',
              dataMappingList: getAutogeneratedZoomMappings({
                control: element[controlId],
                entityResolverRule,
              }),
              isNewAutogeneratedZoom: true,
            },
          })
        : null;

      const autogeneratedZoomId = autogeneratedZoom ? Object.keys(autogeneratedZoom)[0] : null;

      if (autogeneratedZoom) {
        newComponentActionParam.control_3 = {
          element: autogeneratedZoom,
          controlId: autogeneratedZoomId,
          controlParentId: advancedTextBoxControlId,
          previousControlId: controlId,
          optionsSelect,
        };
      }

      batch(() => {
        dispatch(
          addControlToStore({
            element: advancedTextBoxControl,
            controlId: advancedTextBoxControlId,
            controlParentId,
            previousControlId,
            optionsSelect,
          })
        );
        dispatch(
          addControlToStore({
            element,
            controlId,
            controlParentId: advancedTextBoxControlId,
            previousControlId: '',
            optionsSelect,
          })
        );

        autogeneratedZoom &&
          dispatch(
            addControlToStore({
              element: autogeneratedZoom,
              controlId: autogeneratedZoomId,
              controlParentId: advancedTextBoxControlId,
              previousControlId: controlId,
              optionsSelect,
            })
          );
        dispatch(
          updateUserActionArray({
            actionType: ADD_CONTROL_ACTION,
            userChanges: newComponentActionParam,
          })
        );
        dispatchStepChange({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_1 } });
      });
      break;
    }
    case SS_CONTROL_TYPE.GRID: {
      const gridControl = ElementGenerator({
        selectedType: SS_CONTROL_TYPE.GRID,
        controlParentId,
        entityName: nodeProperties?.TableName,
      });
      controlId = gridControl && Object.keys(gridControl)[0];

      const gridColumnControl = ElementGenerator({
        selectedType: SS_CONTROL_TYPE.GRID_COLUMN,
        controlParentId: controlId,
        defaultLabel: DEFAULT_GRID_COLUMN_LABEL,
        entityName: nodeProperties?.TableName,
      });
      const gridColumnControlId = gridColumnControl && Object.keys(gridColumnControl)[0];

      const newComponentActionParam = {
        control_1: {
          element: gridControl,
          controlId,
          controlParentId,
          previousControlId,
          optionsSelect,
        },
        control_2: {
          element: gridColumnControl,
          controlId: gridColumnControlId,
          controlParentId: controlId,
          previousControlId: '',
          optionsSelect,
        },
      };

      batch(() => {
        dispatch(
          addControlToStore({
            element: gridControl,
            controlId,
            controlParentId,
            previousControlId,
            optionsSelect,
          })
        );
        dispatch(
          addControlToStore({
            element: gridColumnControl,
            controlId: gridColumnControlId,
            controlParentId: controlId,
            previousControlId: '',
            optionsSelect,
          })
        );
        dispatch(
          updateUserActionArray({
            actionType: ADD_CONTROL_ACTION,
            userChanges: newComponentActionParam,
          })
        );
        dispatchStepChange({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_1 } });
      });
      break;
    }
    case SS_CONTROL_TYPE.TAB_SET: {
      const tabSetControl = ElementGenerator({
        selectedType: SS_CONTROL_TYPE.TAB_SET,
        controlParentId,
      });
      controlId = tabSetControl && Object.keys(tabSetControl)[0];

      const ssSingleTab = ElementGenerator({
        selectedType: SS_CONTROL_TYPE.SINGLE_TAB,
        controlParentId: controlId,
        defaultLabel: DEFAULT_SINGLE_TAB_HEADER,
      });
      const singleTabControlId = ssSingleTab && Object.keys(ssSingleTab)[0];

      const newComponentActionParam = {
        control_1: {
          element: tabSetControl,
          controlId,
          controlParentId,
          previousControlId,
          optionsSelect,
        },
        control_2: {
          element: ssSingleTab,
          controlId: singleTabControlId,
          controlParentId: controlId,
          previousControlId: '',
          optionsSelect,
        },
      };

      batch(() => {
        dispatch(
          addControlToStore({
            element: tabSetControl,
            controlId,
            controlParentId,
            previousControlId,
            optionsSelect,
          })
        );
        dispatch(
          addControlToStore({
            element: ssSingleTab,
            controlId: singleTabControlId,
            controlParentId: controlId,
            previousControlId: '',
            optionsSelect,
          })
        );
        dispatch(
          updateUserActionArray({
            actionType: ADD_CONTROL_ACTION,
            userChanges: newComponentActionParam,
          })
        );
        dispatchStepChange({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_1 } });
      });
      break;
    }
    case SS_CONTROL_TYPE.SUB_FORM: {
      const subFormControl = ElementGenerator({
        selectedType: SS_CONTROL_TYPE.SUB_FORM,
        controlParentId,
        formName,
      });
      controlId = subFormControl && Object.keys(subFormControl)[0];

      const newComponentActionParam = {
        control_1: {
          element: subFormControl,
          controlId,
          controlParentId,
          previousControlId,
          optionsSelect,
        },
      };

      batch(() => {
        dispatch(
          addControlToStore({
            element: subFormControl,
            controlId,
            controlParentId,
            previousControlId,
            optionsSelect,
          })
        );
        dispatch(
          updateUserActionArray({
            actionType: ADD_CONTROL_ACTION,
            userChanges: newComponentActionParam,
          })
        );
        dispatchStepChange({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_1 } });
      });
      break;
    }

    case SS_CONTROL_TYPE.FILE_VIEWER: {
      const fileViewerControl = ElementGenerator({
        selectedType: SS_CONTROL_TYPE.FILE_VIEWER,
        controlParentId,
        formName,
        entityName: formInfo.formEntityKey,
      });
      controlId = fileViewerControl && Object.keys(fileViewerControl)[0];

      const newComponentActionParam = {
        control_1: {
          element: fileViewerControl,
          controlId,
          controlParentId,
          previousControlId,
          optionsSelect,
        },
      };

      batch(() => {
        dispatch(
          addControlToStore({
            element: fileViewerControl,
            controlId,
            controlParentId,
            previousControlId,
            optionsSelect,
          })
        );
        dispatch(
          updateUserActionArray({
            actionType: ADD_CONTROL_ACTION,
            userChanges: newComponentActionParam,
          })
        );
        dispatchStepChange({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_1 } });
      });
      break;
    }
    default: {
      const entityName =
        selectedType === SS_CONTROL_TYPE.PANEL
          ? Object.keys(entityDefinition)[0]
          : nodeProperties?.TableName;
      element = ElementGenerator({
        selectedType,
        controlParentId,
        isEntity,
        dataModel,
        defaultLabel,
        entityName,
      });
      controlId = element && Object.keys(element)[0];

      if (selectedType === SS_CONTROL_TYPE.MODAL) {
        const entityType = Object.keys(entityDefinition)[0];
        const parentEntityName =
          formModel[controlParentId]?.entityName ??
          findClosestParentWithEntityName(formModel, entityType, controlParentId);

        element[controlId][FORM_MODEL_ATTRIBUTES.DATA_OBJECT] = parentEntityName;
        element[controlId][FORM_MODEL_ATTRIBUTES.DATA_LOOK_UP_TYPE] = 'SMARTSOLVEDATA';
      }

      const newComponentActionParam = {
        control_1: {
          element,
          controlId,
          controlParentId,
          previousControlId,
          optionsSelect,
        },
      };

      batch(() => {
        dispatch(
          addControlToStore({
            element,
            controlId,
            controlParentId,
            previousControlId,
            optionsSelect,
          })
        );
        dispatch(
          updateUserActionArray({
            actionType: ADD_CONTROL_ACTION,
            userChanges: newComponentActionParam,
          })
        );
        dispatchStepChange({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_1 } });
      });
      break;
    }
  }
};

export const unpublishFormEditor = (formKey) => async (dispatch) => {
  const formResponse = await unpublishForm(formKey);

  if (!formResponse.hasError) {
    dispatch(addSuccess({ message: 'Form Unpublished Successfully' }));
  } else {
    dispatch(handleErrors(formResponse.errors));
  }
};

export const replaceDatasource = ({ datasourceKey, datasourceProperties }) => ({
  type: REPLACE_DATASOURCE,
  payload: { datasourceKey, datasourceProperties },
});

export const removeFromDeletedElementArray = ({ controlId }) => ({
  type: REMOVE_FROM_DELETED_ELEMENT_ARRAY,
  payload: { controlId },
});

export const addElementsToFormModel = ({ elements }) => ({
  type: ADD_ELEMENTS_TO_FORM_MODEL,
  payload: { elements },
});

export const replaceAddedElementsToFormModel = ({ addedElements }) => ({
  type: REPLACE_ADDED_ELEMENTS_TO_FORM_MODEL,
  payload: { addedElements },
});

export const addControlToStore = ({
  element,
  controlId,
  controlParentId,
  previousControlId,
  optionsSelect,
}) => {
  return (dispatch) => {
    batch(() => {
      dispatch(updateFormModelAddNewController({ element }));
      dispatch(
        updateFormModelParentElementAddNewController({
          controlParentId,
          childNodeId: controlId,
          previousControlId,
        })
      );
      dispatch(addNewElementArray({ element, optionsSelect, previousControlId }));
    });
  };
};

export const undoDataSourceAction = (userAction) => {
  return (dispatch) => {
    const controlChanges = {
      dataSourceKey: userAction.controlPrevState?.dataSourceKey,
      dataValueField: userAction.controlPrevState?.dataValueField,
      dataTextField: userAction.controlPrevState?.dataTextField,
      dataSourceFilter: userAction.controlPrevState?.dataSourceFilter,
    };
    dispatch(
      replaceFromChangedDatasource({
        dataSourcePrevState: userAction.currentChangedDataSource,
        dataSourceKey: userAction.nextChangedDataSource.dataSourceKey,
      })
    );
    if (userAction.datasourceAction === 'add') {
      batch(() => {
        dispatch(
          deleteChangedDatasources({
            dataSourcesKeys: [userAction.nextChangedDataSource.dataSourceKey],
          })
        );
        userAction.controlPrevState &&
          dispatch({
            type: UPDATE_CONTROL,
            payload: {
              id: userAction.controlPrevState.controlId,
              controlChanges: { ...controlChanges },
            },
          });
      });
    }
    if (userAction.datasourceAction === 'edit') {
      batch(() => {
        dispatch(
          replaceDatasource({
            datasourceKey: userAction.pureDataSource.dataSourceKey,
            datasourceProperties: userAction.currentDataSourceState,
          })
        );
        userAction.controlPrevState &&
          dispatch({
            type: UPDATE_CONTROL,
            payload: {
              id: userAction.controlPrevState.controlId,
              controlChanges: { ...controlChanges },
            },
          });
      });
    }
    if (userAction.datasourceAction === 'delete') {
      batch(() => {
        dispatch(
          replaceDatasource({
            datasourceKey: userAction.pureDataSource.dataSourceKey,
            datasourceProperties: userAction.currentDataSourceState,
          })
        );
        userAction.controlPrevState &&
          dispatch({
            type: UPDATE_CONTROL,
            payload: {
              id: userAction.controlPrevState.controlId,
              controlChanges: { ...controlChanges },
            },
          });
      });
    }
  };
};

export const undoDeleteControlAction = (userAction) => {
  return (dispatch) => {
    const controlIndex = userAction.parentChildrenNodes.findIndex(
      (item) => item === userAction.element.controlId
    );
    const prevControlId = userAction.parentChildrenNodes[controlIndex - 1] ?? '';

    if (!userAction.addedElements) {
      dispatch(removeFromDeletedElementArray({ controlId: userAction.element.controlId }));
    } else {
      dispatch(
        addElementsToFormModel({
          elements: {
            [userAction.element.controlId]: userAction.element,
            ...userAction.childElements,
          },
        })
      );
      dispatch(replaceAddedElementsToFormModel({ addedElements: userAction.addedElements }));
    }
    dispatch(
      updateFormModelParentElementAddNewController({
        controlParentId: userAction.element.parent,
        childNodeId: userAction.element.controlId,
        previousControlId: prevControlId,
      })
    );
  };
};

export const undoMoveControlAction = (userAction) => {
  return (dispatch) => {
    if (userAction.moveType === MOVE_BUTTON_TYPES.UP) {
      dispatch(changeElementPositionFormModel(userAction.element, MOVE_BUTTON_TYPES.DOWN, false));
    }
    if (userAction.moveType === MOVE_BUTTON_TYPES.DOWN) {
      dispatch(changeElementPositionFormModel(userAction.element, MOVE_BUTTON_TYPES.UP, false));
    }
    if (userAction.moveType === 'DND') {
      batch(() => {
        dispatch({
          type: UPDATE_CONTROL,
          payload: {
            id: userAction.parentComponent.controlId,
            controlChanges: { childrenNodes: userAction.parentComponent.childrenNodes },
          },
        });
        dispatch(
          updateMovedFieldsFormModelAfterMove(
            userAction.parentComponent.controlId,
            userAction.dragId
          )
        );
      });
    }
  };
};

export const redoDataSourceAction = (userAction) => {
  return (dispatch) => {
    const controlChanges = {
      dataSourceKey: userAction.nextChangedDataSource.dataSourceKey ?? '',
      dataValueField: '',
      dataTextField: '',
      dataSourceFilter: '',
    };
    dispatch({
      type: CHANGE_DATASOURCE,
      payload: {
        dataSource: userAction.pureDataSource,
      },
    });
    if (userAction.datasourceAction === 'add') {
      batch(() => {
        dispatch(
          updateDatasourceList({
            datasource: {
              ...userAction.nextChangedDataSource,
              changeType: 'ADDED',
              formLastModified: '',
            },
          })
        );

        userAction.controlPrevState &&
          dispatch({
            type: UPDATE_CONTROL,
            payload: {
              id: userAction.controlPrevState.controlId,
              controlChanges: { ...controlChanges },
            },
          });
      });
    }
    if (userAction.datasourceAction === 'edit') {
      batch(() => {
        dispatch(
          updateDatasourceList({
            datasource: {
              ...userAction.nextChangedDataSource,
              changeType: 'MODIFIED',
            },
          })
        );
        userAction.controlPrevState &&
          dispatch({
            type: UPDATE_CONTROL,
            payload: {
              id: userAction.controlPrevState.controlId,
              controlChanges: { ...controlChanges },
            },
          });
      });
    }
    if (userAction.datasourceAction === 'delete') {
      batch(() => {
        dispatch(
          deleteChangedDatasources({
            dataSourcesKeys: [userAction.nextChangedDataSource.dataSourceKey],
          })
        );
        userAction.controlPrevState &&
          dispatch({
            type: UPDATE_CONTROL,
            payload: {
              id: userAction.controlPrevState.controlId,
              controlChanges: { ...controlChanges },
            },
          });
      });
    }
  };
};

export const redoDeleteControlAction = (userAction) => {
  return (dispatch) => {
    if (!userAction.addedElements) {
      dispatch(addDeletedNewElementArray(userAction.element));
    }
    if (userAction.addedElements) {
      dispatch(updateFormModelDeleteController(userAction.deletedControlIds));
      dispatch(updateAddedElementsAfterDeletion());
    }
    dispatch(
      updateFormModelParentElementDeleteNewController(
        userAction.parent,
        userAction.element.controlId
      )
    );
  };
};

export const redoMoveControlAction = (userAction) => {
  return (dispatch) => {
    if (userAction.moveType === MOVE_BUTTON_TYPES.UP) {
      dispatch(changeElementPositionFormModel(userAction.element, MOVE_BUTTON_TYPES.UP, false));
    }
    if (userAction.moveType === MOVE_BUTTON_TYPES.DOWN) {
      dispatch(changeElementPositionFormModel(userAction.element, MOVE_BUTTON_TYPES.DOWN, false));
    }
    if (userAction.moveType === 'DND') {
      batch(() => {
        dispatch(
          moveControlByDndWithinContainer(
            userAction.dragId,
            userAction.dropId,
            userAction.parentComponent
          )
        );
        dispatch(
          updateMovedFieldsFormModelAfterMove(
            userAction.parentComponent.controlId,
            userAction.dragId
          )
        );
      });
    }
  };
};

export const undoUserAction = () => {
  return (dispatch, getState) => {
    const { userActions, formModel } = getState().formDesigner.EDITOR;

    const { actions, actionPointer } = userActions;
    const userAction = actions[actionPointer].userChanges;

    dispatch({ type: UNDO_USER_ACTION });
    switch (actions[actionPointer].actionType) {
      case UPDATE_CONTROL_ACTION: {
        dispatch({
          type: UPDATE_CONTROL,
          payload: {
            id: userAction.prevItemState.id,
            controlChanges: { ...userAction.prevItemState.changedPropertyPrevState },
          },
        });

        if (userAction.deletedElementParams) {
          dispatch(undoDeleteControlAction(userAction.deletedElementParams));
        }
        break;
      }

      case UPDATE_DATASOURCES_ACTION: {
        dispatch(undoDataSourceAction(userAction));
        break;
      }

      case DELETE_CONTROL_ACTION: {
        dispatch(undoDeleteControlAction(userAction));
        break;
      }

      case ADD_CONTROL_ACTION: {
        const controlId = userAction.control_1.controlId;
        const newControl = formModel[controlId];
        dispatch(deleteElementFromFormModel(newControl, false));
        break;
      }

      case MOVE_CONTROL_ACTION: {
        dispatch(undoMoveControlAction(userAction));
        break;
      }
      // eslint-disable-next-line no-fallthrough
      default:
    }
  };
};

export const redoUserAction = () => {
  return (dispatch, getState) => {
    const { userActions } = getState().formDesigner.EDITOR;

    const { actions, actionPointer } = userActions;

    const prevActionPointer = actionPointer - 1;

    const userAction = actions[prevActionPointer].userChanges;
    dispatch({ type: REDO_USER_ACTION });
    switch (actions[prevActionPointer].actionType) {
      case UPDATE_CONTROL_ACTION: {
        dispatch({
          type: UPDATE_CONTROL,
          payload: {
            id: userAction.itemChanges.id,
            controlChanges: { ...userAction.itemChanges.controlChanges },
          },
        });

        if (userAction.deletedElementParams) {
          dispatch(redoDeleteControlAction(userAction.deletedElementParams));
        }
        break;
      }

      case UPDATE_DATASOURCES_ACTION: {
        dispatch(redoDataSourceAction(userAction));
        break;
      }

      case DELETE_CONTROL_ACTION: {
        dispatch(redoDeleteControlAction(userAction));
        break;
      }

      case ADD_CONTROL_ACTION: {
        dispatch(addControlToStore(userAction.control_1));
        userAction.control_2 && dispatch(addControlToStore(userAction.control_2));
        userAction.control_3 && dispatch(addControlToStore(userAction.control_3));
        break;
      }

      case MOVE_CONTROL_ACTION: {
        dispatch(redoMoveControlAction(userAction));
        break;
      }
      // eslint-disable-next-line no-fallthrough
      default:
    }
  };
};

export const importForm = ({ file, redirectToFormEditor }) => async (dispatch) => {
  const response = await importFormApi(file);

  if (response.hasError) {
    throw response.errors;
  } else {
    const { formInfo } = response.formModel;

    const formEntityKey = formInfo.formEntityKey;

    dispatch(
      loadEditor({
        entityViewName: formEntityKey,
        entityType: formEntityKey,
        containerWorkflowKey: '',
        workflowKey: '',
        stepId: '',
        itmId: '',
        workflowId: '',
        formKey: formInfo.formKey,
        formId: '',
        entityName: formEntityKey,
        isCreateForm: false,
        formEntity: formEntityKey,
        isImportForm: true,
        formDefinition: response.formModel,
      })
    );

    dispatch(addSuccess({ message: 'Form Imported Successfully' }));

    redirectToFormEditor();
  }
};

const setSearchResult = ({ searchText, searchId, searchIds }) => ({
  type: SET_SEARCH_RESULT,
  payload: {
    searchText,
    searchId,
    searchIds,
  },
});

export const handleEditorSearch = (newSearchText) => (dispatch, getState) => {
  const { formModel, searchResult = {} } = getState().formDesigner[FORM_KEYS.EDITOR];
  const { searchId: prevSearchId } = searchResult;

  const newSearchIds = getSearchIds(formModel, newSearchText);

  if (!newSearchIds.length) {
    dispatch(
      setSearchResult({
        searchText: newSearchText,
        searchId: null,
        searchIds: [],
      })
    );
    return;
  }

  const newSearchId = newSearchIds.includes(prevSearchId) ? prevSearchId : newSearchIds[0];

  batch(() => {
    dispatch(setSelectedControl(newSearchId, true));
    dispatch(
      setSearchResult({
        searchText: newSearchText,
        searchId: newSearchId,
        searchIds: newSearchIds,
      })
    );
  });

  scrollIntoEditor(newSearchId);
};

export const switchEditorSearchResult = (isNext) => (dispatch, getState) => {
  const { formModel, searchResult = {} } = getState().formDesigner[FORM_KEYS.EDITOR];
  const { searchText, searchId: prevSearchId } = searchResult;

  const newSearchIds = getSearchIds(formModel, searchText);
  let newSearchId = newSearchIds.includes(prevSearchId) ? prevSearchId : newSearchIds[0];
  const index = newSearchIds.indexOf(newSearchId);

  if (isNext) {
    newSearchId = newSearchIds[index + 1];

    if (!newSearchId) {
      newSearchId = newSearchIds[0];
    }
  } else {
    newSearchId = newSearchIds[index - 1];

    if (!newSearchId) {
      newSearchId = _.last(newSearchIds);
    }
  }

  batch(() => {
    dispatch(setSelectedControl(newSearchId, true));
    dispatch(
      setSearchResult({
        searchText,
        searchId: newSearchId,
        searchIds: newSearchIds,
      })
    );
  });

  scrollIntoEditor(newSearchId);
};
